// Shared disclaimer text (F8.3). Used by TopBar + Footer + Report.

export const DISCLOSURE =
  'Software output is not a licensed independent appraisal. This tool produces calculation evidence and structured analysis to support, not replace, a qualified independent appraisal. Fair market values shown are model outputs and should be reviewed by a qualified appraiser before reliance for IRC §409A compliance.';
